module.exports = __webpack_public_path__ + "static/OneDotCd-BoldItalic.6f3572ea.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-BoldItalic.eot
// module id = 741
// module chunks = 114276838955818